import AppSettingsContext from "@/contexts/AppSettingsContext";
import IsNextYearEarlyRegistrationContext from "@/contexts/IsNextYearEarlyRegistrationContext";
import { useContext, useMemo } from 'react';

export const useRegistrationYear = () => {
    const { data: appSettings } = useContext(AppSettingsContext);
    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);

    const registrationYear = useMemo(() => {
        const currentRegistrationYear = appSettings?.currentRegistrationYear ?? new Date().getFullYear();

        return isNextYearEarlyRegistration ? currentRegistrationYear + 1 : currentRegistrationYear;
    }, [appSettings?.currentRegistrationYear, isNextYearEarlyRegistration]);

    return registrationYear;
};

export default useRegistrationYear;